import '@src/scss/components/Loading.scss';
const Loader=()=>{
    return (
    <div className="loading-page">
        <div className="loader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
    )
}

export {Loader};